var Afterpay = {};


Afterpay.loadScript = function(url, callback) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  if (script.readyState) { // I.E.
    script.onreadystatechange = function() {
      if (script.readyState == 'loaded' || script.readyState == 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else { // Others
    script.onload = function() {
      callback();
    };
  }
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
};

Afterpay.supportedCurrencies = [
  'AUD',
  'NZD',
  'USD'
];

Afterpay.supportedThemes = {
  'alchemy': {
    'selector': '.quadd-wrapper'
  },
  'atlantic': {
    'selector': 'p.price'
  },
  'blockshop': { // tested on https://themes.shopify.com/themes/blockshop/styles/deli/preview
    'selector': 'article .prices',
    'paragraph_css': {
      'margin-top': '-1em',
      'margin-bottom': '2em'
    }
  },
  'boundless': { // tested on https://themes.shopify.com/themes/boundless/styles/black-white/preview
    'selector': '#AddToCartForm-product-template .product__price',
  'cart': {
      'static_page': {
        'selector': 'span.cart__subtotal'
      },
    },
    'paragraph_css': {
      'margin-top': '-20px'
    }
  },
  'brooklyn': { // tested on https://themes.shopify.com/themes/brooklyn/styles/classic/preview
    'selector': '#ProductPrice',
  'cart': {
      'static_page': {
        'selector': '.cart__row--table:last'
      },
      'dynamic_content': {
        'target_selector': '#CartDrawer #CartContainer',
        'addedNode_selector': 'form.ajaxcart',
        'subtotal_selector': '.ajaxcart__footer .grid--full',
        'paragraph_css': {
          'text-align': 'right'
        },
        'after_render': function($, $afterpay_paragraph) {
          var $cart_drawer_inner = $('#CartContainer .ajaxcart__inner--has-fixed-footer');
          var $cart_drawer_footer = $('#CartContainer .ajaxcart__footer--fixed');
          var new_height = $cart_drawer_footer.outerHeight() + $afterpay_paragraph.outerHeight(true);
          $cart_drawer_inner.css('bottom', new_height + 'px');
          $cart_drawer_footer.css('height', new_height + 'px');
        }
      }
    },
  },
  'debut': { // tested on https://themes.shopify.com/themes/debut/styles/default/preview
    'selector': '.product-single__price',
  'cart': {
      'static_page': {
        'selector': '.cart__footer .cart__subtotal'
      },
    },
    'paragraph_css': {
      'margin-top': '-20px',
      'margin-bottom': '40px'
    }
  },
  'district': { // tested on https://themes.shopify.com/themes/district/styles/district/preview
    'selector': '#ComparePrice-product-template',
    'paragraph_css': {
      'margin-top': '0.3rem',
      'display': 'block',
      'font-style': 'normal'
    }
  },
  'empire': { // tested on https://themes.shopify.com/themes/empire/styles/supply/preview
    'selector': '.product--container .product-pricing',
    'paragraph_css': {
      'line-height': '1.5',
      'margin-top': '10px',
      'margin-bottom': '22px'
    }
  },
  'fashionopolism': { // tested on https://themes.shopify.com/themes/fashionopolism/styles/secret-sale/preview
    'selector': '.product-prices'
  },
  'flow': { // tested on https://themes.shopify.com/themes/flow/styles/byron/preview
    'selector': '#ProductPrice',
    'paragraph_css': {
      'margin-top': '-20px',
      'margin-bottom': '30px'
    }
  },
  'grid': { // tested on https://themes.shopify.com/themes/grid/styles/light/preview
    'selector': '.product-details .product-price',
    'paragraph_css': {
      'margin-top': '-35px',
      'margin-bottom': '40px'
    }
  },
  'icon': {
    'selector': '#product-price' // tested on https://themes.shopify.com/themes/icon/styles/dolce/preview
  },
  'jumpstart': { // tested on https://themes.shopify.com/themes/jumpstart/styles/jumpstart/preview
    'selector': '#AddToCartForm .price:last, #ProductPrice-product-template',
  'cart': {
      'static_page': {
        'selector': 'span.h3.cart__subtotal'
      },
    },
  },
  /*'loft': { // skipped because would need two <p> tags and a <style> tag for media queries to support both desktop and mobile.
    'selector': '#ProductPrice',
    'paragraph_css': {
      'margin-top': '-0.5em',
      'margin-bottom': '1.5em'
    }
  },*/
  'minimal': { // tested on https://themes.shopify.com/themes/minimal/styles/vintage/preview
    'selector': '.product-single__prices',
  'cart': {
      'static_page': {
        'selector': '.h5.cart__subtotal'
      },
    },
    'paragraph_css': {
      'margin-top': '-15px'
    }
  },
  'modular': {
    'selector': '.productForm .product-price',
    'paragraph_css': {
      'margin-top': '-1rem',
      'margin-bottom': '1.5rem'
    }
  },
  'motion': {
    'selector': '.product-single__meta .product__price' // may have a '.product__price--compare' next to it, but it should be on the left.
  },
  'narrative': { // tested on https://themes.shopify.com/themes/narrative/styles/warm/preview
    'selector': '.product__content .product__price',
  'cart': {
      'static_page': {
        'selector': '.cart-footer .cart-footer__subtotal'
      },
    },
    'paragraph_css': {
      'margin-top': '-10px',
      'text-align': 'center'
    }
  },
  'pacific': {
    'selector': '.product-price'
  },
  'parallax': { // tested on https://themes.shopify.com/themes/parallax/styles/aspen/preview
    'selector': '.product_section .modal_price',
    'cart': {
      'static_page': {
        'selector': 'form .subtotal_amount'
      }
    }
  },
  'pipeline': { // tested on https://themes.shopify.com/themes/pipeline/styles/bright/preview
    'selector': '#ComparePriceWrapper-product',
    'paragraph_css': {
      'margin-top': '15px',
      'line-height': '1.5',
      'letter-spacing': '0',
      'font-size': '14px',
      'text-transform': 'none',
      'color': '#000'
    }
  },
  'pop': { // tested on https://themes.shopify.com/themes/pop/styles/bone/preview
    'selector': '.product-single__price',
  'cart': {
      'static_page': {
        'selector': 'span.cart__subtotal'
      },
    },
  },
  'providence': {
    'selector': '.pricing'
  },
  'retina': { // tested on https://themes.shopify.com/themes/retina/styles/austin/preview
    'selector': '.modal_price',
    'paragraph_css': {
      'margin-top': '-15px',
      'margin-bottom': '20px'
    }
  },
  'showtime': { // tested on https://themes.shopify.com/themes/showtime/styles/cooktime/preview
    'selector': '.desc_blk_bot .price',
    'paragraph_css': {
      'float': 'none',
      'clear': 'both',
      'margin-bottom': '1rem',
      'text-align': 'center'
    }
  },
  'simple': { // tested on https://themes.shopify.com/themes/simple/styles/light/preview
    'selector': '#ProductSection .product-single__prices',
  'cart': {
      'static_page': {
        'selector': 'span.cart__subtotal.h3'
      },
    },
    'paragraph_css': {
      'margin-top': '-15px',
      'margin-bottom': '30px'
    }
  },
  'supply': { // tested on https://themes.shopify.com/themes/supply/styles/blue/preview
    'selector': 'ul.product-meta',
    'cart': {
      'static_page': {
        'selector': '.h1.cart-subtotal--price'
      },
      'dynamic_content': {
        'target_selector': '#ajaxifyCart.ajaxifyCart--content',
        'addedNode_selector': 'form.cart-form',
        'subtotal_selector': '.h1.cart-subtotal--price'
      }
    }
  },
  'symmetry': { // tested on https://themes.shopify.com/themes/symmetry/styles/beatnik/preview
    'selector': '#main-product-detail .price-area'
  },
  'testament': { // tested on https://themes.shopify.com/themes/testament/styles/genesis/preview
    'selector': '#product-price'
  },
  'venture': { // tested on https://themes.shopify.com/themes/venture/styles/snowboards/preview
    'selector': 'ul.product-single__meta-list',
  'cart': {
      'static_page': {
        'selector': 'p#CartSubtotal'
      },
    },
    'paragraph_css': {
      'margin-top': '10px'
    }
  },
  'venue': { // tested on https://themes.shopify.com/themes/venue/styles/evening/preview
    'selector': 'h3.product-single__price-text',
    'paragraph_css': {
      'line-height': '1.5'
    }
  },
  'classic': { // tested on local; classic is the default theme.
    'selector': '.product-single__prices',
    'paragraph_css': {
      'margin-top': '-15px',
      'margin-bottom': '30px'
    }
  }
};

Afterpay.supportedTheme = false;

Afterpay.mutationObserver = false;

Afterpay.commonElements = {
  'product': {
    'price_selector': [
      '#ProductPrice',
      '#product-price',
      '#ProductSection .product-single__prices',
      '.product-details .product-price',
      '.product--container .product-pricing',
      '.productForm .product-price',
      '.product-single__meta .product__price',
      '.product__content .product__price',
      'p.modal_price',
      'ul.product-meta',
      'ul.product-single__meta-list',
      '.product-single__price',
      '.product-single__prices',
      '.product__price'
    ]
  },
  'cart': {
    'static_page': {
      'subtotal_selector': [
        '#CartSubtotal',
        'form .subtotal_amount',
        '.cart__footer .cart__subtotal',
        '.cart-footer .cart-footer__subtotal',
        'span.cart__subtotal',
        '.h1.cart-subtotal--price',
        '.cart__row--table:last'
      ]
    }
  }
};

/*
 * Define our own function for this, since Array.prototype.indexOf is not supported in IE < 9.
 * Use the native function if it exists.
 */
Afterpay.arrayContainsElement = function(arr, element) {
  var i;

  if (Array.prototype.indexOf) {
    return arr.indexOf(element) > -1;
  }

  for (i = 0; i < arr.length; i++) {
    if (arr[i] == element) {
      return true;
    }
  }

  return false;
}

Afterpay.generateInstalmentHTML = function(variant_price_in_cents) {
  var a = Math.round(variant_price_in_cents / 4);
  var b = a / 100;
  var c = b.toFixed(2);
  return '$' + c + '&nbsp;' + afterpay_shop_currency.toUpperCase();
};

Afterpay.generateOutsideLimitHTML = function($afterpay_paragraph) {
  $afterpay_paragraph.find('.afterpay-text1')
    .html('Installments by ');
  $afterpay_paragraph.find('.afterpay-logo')
    .insertAfter($afterpay_paragraph.find('.afterpay-text1'));
  $afterpay_paragraph.find('.afterpay-text2')
    .html(' available between ');
  $afterpay_paragraph.find('.afterpay-instalments')
    .html(Afterpay.generateCurrencyHTML(afterpay_min) + ' - ' + Afterpay.generateCurrencyHTML(afterpay_max))
    .insertAfter($afterpay_paragraph.find('.afterpay-text2'));
  $afterpay_paragraph.find('.afterpay-link-inner').html('Learn more');
  return $afterpay_paragraph;
};

Afterpay.generateInsideLimitHTML = function($afterpay_paragraph) {
  if ($afterpay_paragraph.find('.afterpay-text1').html() == 'Installments by ') {
    if (Afterpay.supportedTheme) {
      $afterpay_paragraph.find('.afterpay-text1')
        .html('or 4 installments of ');
    } else {
      $afterpay_paragraph.find('.afterpay-text1')
        .html('Pay 4 installments of ');
    }
    $afterpay_paragraph.find('.afterpay-logo')
      .insertAfter($afterpay_paragraph.find('.afterpay-instalments'));
    $afterpay_paragraph.find('.afterpay-text2')
      .html(' by ').insertBefore($afterpay_paragraph.find('.afterpay-logo'));
    $afterpay_paragraph.find('.afterpay-link-inner').html('More info');
  }
  return $afterpay_paragraph;
};

Afterpay.generateCurrencyHTML = function(price_decimal) {
  // @todo Format with commas (thousand separators).
  // @todo Truncate decimals for big integers.
  var a = Math.round(price_decimal, 2);
  var b = a.toFixed(2);
  return '$' + b + '&nbsp;' + afterpay_shop_currency.toUpperCase();
}

Afterpay.launchPopup = function($, event) {
  event.preventDefault();

  var $popup_wrapper, $popup_outer, $popup_inner, $a, $img, $close_button;

  $popup_wrapper = $('#afterpay-popup-wrapper');

  if ($popup_wrapper.length > 0) {
    $popup_wrapper.show();
  } else {
    $popup_wrapper = $(document.createElement('div'))
      .attr('id', 'afterpay-popup-wrapper')
      .css({
        'position': 'fixed',
        'z-index': 9999999999,
        'left': 0,
        'top': 0,
        'right': 0,
        'bottom': 0,
        'overflow': 'auto'
      })
      .appendTo('body')
      .on('click', function(event) {
        Afterpay.closePopup($, event);
      });

    $popup_outer = $(document.createElement('div'))
      .attr('id', 'afterpay-popup-outer')
      .css({
        'display': '-ms-flexbox',
        'display': '-webkit-flex',
        'display': 'flex',
        '-webkit-justify-content': 'center',
        '-ms-flex-pack': 'center',
        'justify-content': 'center',
        '-webkit-align-content': 'center',
        '-ms-flex-line-pack': 'center',
        'align-content': 'center',
        '-webkit-align-items': 'center',
        '-ms-flex-align': 'center',
        'align-items': 'center',
        'width': '100%',
        'min-height': '100%',
        'background-color': 'rgba(0, 0, 0, 0.80)'
      })
      .appendTo($popup_wrapper);

    $popup_inner = $(document.createElement('div'))
      .attr('id', 'afterpay-popup-inner')
      .css({
        'position': 'relative',
        'background-color': '#fff'
      })
      .appendTo($popup_outer);

    $a = $(document.createElement('a'));

    if (afterpay_shop_currency == 'USD') {
      $a.attr('href', 'https://www.pxclothing.com/pages/afterpay');
    } else {
      $a.attr('href', 'https://www.afterpay.com/terms');
    }

    $a
      .attr('target', '_blank')
      .css({
        'display': 'block'
      })
      .appendTo($popup_inner);

    $img = $(document.createElement('img'));


    if (afterpay_shop_currency == 'USD') {
      if ($(window).width() > 640) {
        $img.attr('src', "//www.pxclothing.com/cdn/shop/t/71/assets/PX_S18AfterPay-Horz.jpg?v=78196721299153741841764709202");
      } else {
        $img.attr('src', "//www.pxclothing.com/cdn/shop/t/71/assets/PX_S18AfterPay-Vert2.jpg?v=52476420607352858831764709203");
      }
    } else {
      if ($(window).width() > 640) {
        $img.attr('src', 'https://static.afterpay.com/lightbox-desktop.png');
      } else {
        $img.attr('src', 'https://static.afterpay.com/lightbox-mobile.png');
      }
    }

    $img
      .css({
        'display': 'block',
        'width': '100%'
      })
      .appendTo($a)
      .on('click', function(event) {
        event.stopPropagation();
      });

    $close_button = $(document.createElement('a'))
      .attr('href', '#')
      .css({
        'position': 'absolute',
        'right': '8px',
        'top': '8px'
      })
      .html('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" version="1.1" width="32px" height="32px"><g id="surface1"><path style=" " d="M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 12.21875 10.78125 L 10.78125 12.21875 L 14.5625 16 L 10.78125 19.78125 L 12.21875 21.21875 L 16 17.4375 L 19.78125 21.21875 L 21.21875 19.78125 L 17.4375 16 L 21.21875 12.21875 L 19.78125 10.78125 L 16 14.5625 Z "/></g></svg>')
      .appendTo($popup_inner)
      .on('click', function(event) {
        Afterpay.closePopup($, event);
      });
  }
}

Afterpay.closePopup = function($, event) {
  event.preventDefault();

  $('#afterpay-popup-wrapper').hide();
}

Afterpay.renderParagraph = function($, options) {
  var $afterpay_paragraph = $(document.createElement('p'))
    .addClass('afterpay-paragraph');

  if (afterpay_product !== null) {
    $afterpay_paragraph.attr('data-product-id', afterpay_product.id);
  }

  var $text1 = $(document.createElement('span'))
    .addClass('afterpay-text1')
    .appendTo($afterpay_paragraph);

  if (afterpay_shop_currency == 'USD') {
    $text1.html('or 4 installments of ');
  } else {
    $text1.html('or make 4 interest-free payments of ');
  }

  var $afterpay_instalments = $(document.createElement('strong'))
    .addClass('afterpay-instalments')
    .html(Afterpay.generateInstalmentHTML(options.total_price))
    .appendTo($afterpay_paragraph);

  var $text2 = $(document.createElement('span'))
    .addClass('afterpay-text2')
    .appendTo($afterpay_paragraph);

  if (afterpay_shop_currency == 'USD') {
    $text2.html(' by ');
  } else {
    $text2.html(' fortnightly with ');
  }

  var $afterpay_logo = $(document.createElement('img'))
    .addClass('afterpay-logo')
    .css({'vertical-align': 'middle'})
    .attr('src', 'https://static.afterpay.com/integration/product-page/logo-afterpay-' + afterpay_logo_theme + '.png')
    .attr('srcset', 'https://static.afterpay.com/integration/product-page/logo-afterpay-' + afterpay_logo_theme + '.png 1x, https://static.afterpay.com/integration/product-page/logo-afterpay-' + afterpay_logo_theme + '@2x.png 2x, https://static.afterpay.com/integration/product-page/logo-afterpay-' + afterpay_logo_theme + '@3x.png 3x')
    .attr('width', '100')
    .attr('height', '21')
    .attr('alt', 'Afterpay')
    .appendTo($afterpay_paragraph);

  var $text3 = $(document.createElement('span'))
    .addClass('afterpay-text3')
    .html('&nbsp;')
    .appendTo($afterpay_paragraph);

  var $afterpay_link = $(document.createElement('a'))
    .addClass('afterpay-link');

  if (afterpay_shop_currency == 'USD') {
    $afterpay_link.attr('href', 'https://www.afterpay.com/purchase-payment-agreement');
  } else {
    $afterpay_link.attr('href', 'https://www.afterpay.com/terms');
  }

  $afterpay_link
    .attr('target', '_blank')
    .on('click', function(event) {
      Afterpay.launchPopup($, event);
    })
    .appendTo($afterpay_paragraph);

//   var $u = $(document.createElement('u'))
//     .addClass("fa fa-info-circle").attr("aria-hidden", true).css({
//             "color": "#000000",
//       		"text-decoration": "none"
//      }).appendTo($afterpay_link);
  
  
  var $u = $(document.createElement('u')).html('&#9432;').css({
             "color": "#000000",
       		"text-decoration": "none"
    }).appendTo($afterpay_link);
  
//   var $u = $(document.createElement('u')).text().appendTo($afterpay_link);

  return $afterpay_paragraph;
}

Afterpay.extractPriceFromHTML = function(html_str) {
  var total_price_str = html_str.replace(/[^0-9.]/, '');
  if (total_price_str == '') {
    // @todo  Handle this differently from $0.00,
    //        e.g. return something that won't evaluate to
    //        type 'number'.
  }
  var total_price = parseFloat(total_price_str);
  var total_price_in_cents = Math.round(total_price * 100) / 100;

  return total_price_in_cents;
}

Afterpay.updateParagraph = function($afterpay_paragraph, total_price_in_cents) {
  if (total_price_in_cents >= afterpay_min && total_price_in_cents <= afterpay_max) {
    $afterpay_paragraph.show();
    if (afterpay_shop_currency == 'USD') {
      $afterpay_paragraph = Afterpay.generateInsideLimitHTML($afterpay_paragraph);
    }
    $afterpay_paragraph.find('.afterpay-instalments').html(Afterpay.generateInstalmentHTML(total_price_in_cents * 100));
  } else if (afterpay_shop_currency == 'USD') {
    $afterpay_paragraph.show();
    $afterpay_paragraph = Afterpay.generateOutsideLimitHTML($afterpay_paragraph);
  } else {
    $afterpay_paragraph.hide();
  }
}

Afterpay.initProductPage = function($) {

  // Define Variables

  var $elements = null;
  var $target_element = null;
  var $watched_element = null;
  var injection_position = 'after';
  var $afterpay_paragraph;
  var dom_mutation_observer;

  $afterpay_paragraph = Afterpay.renderParagraph($, {
    'total_price': afterpay_current_variant.price
  });

  if (typeof afterpay_product_selector != 'undefined') {

    // Selector has been specified in the theme.liquid file.
    // Use this instead of running search passes.

    Afterpay.supportedTheme = true;

    $elements = $(afterpay_product_selector);
    if ($elements.length > 0) {
      $target_element = $elements.first();
      
      afterpay_ga('send', 'event', 'JS Include', 'Product Page - Search Complete', 'Manual Override');
    }
  } else {

    // Search Pass 1: Theme Name Exact Match

    if (Afterpay.supportedTheme) {
      // The active theme is supported.
      // I.e: We know exactly where to inject the Afterpay HTML.

      $elements = $(Afterpay.supportedTheme.selector);
      if ($elements.length > 0) {
        $target_element = $elements.first();
        if (Afterpay.supportedTheme.paragraph_css) {
          $afterpay_paragraph.css(Afterpay.supportedTheme.paragraph_css);
        }

        afterpay_ga('send', 'event', 'JS Include', 'Product Page - Search Complete', 'Theme Name Exact Match');
      }
    }

    // Search Pass 2: Theme Name Partial Match

    else {
      $elements = null;

      $.each(Afterpay.supportedThemes, function(propertyName, valueOfProperty) {
        var pattern = new RegExp(propertyName, 'i');
        if (pattern.test(afterpay_theme_name)) {
          // The active theme name contains the name of a supported theme.
          // E.g.:
          //  - "Copy of Debut"      matches /Debut/i
          //  - "Supply with LayBuy" matches /Supply/i
          //  - "Pipeline2"          matches /Pipeline/i
          // Assume this is a supported theme that has been renamed.

          Afterpay.supportedTheme = Afterpay.supportedThemes[propertyName];
          $elements = $(Afterpay.supportedTheme.selector);
        }
      });

      if ($elements !== null && $elements.length > 0) {
        $target_element = $elements.first();
        if (Afterpay.supportedTheme.paragraph_css) {
          $afterpay_paragraph.css(Afterpay.supportedTheme.paragraph_css);
        }

        afterpay_ga('send', 'event', 'JS Include', 'Product Page - Search Complete', 'Theme Name Partial Match');
      }
    }

    // Search Pass 3: Common Elements
    //
    // If this pass finds a match it is similar to an exact match
    // for a supported theme name, except the paragraph styling
    // will be left as default.

    if ($target_element === null) {
      $.each(Afterpay.commonElements.product.price_selector, function(indexInArray, value) {
        $elements = $(value);
        if ($elements.length > 0) {
          Afterpay.supportedTheme = true;

          $target_element = $elements.first();

          afterpay_ga('send', 'event', 'JS Include', 'Product Page - Search Complete', 'Common Element Match');

          return false;
        }
      });
    }

    // Search Pass 4: Cart Form Fallback

    if ($target_element === null) {
      // The active theme is NOT supported, OR the expected markup was not available.
      // We don't know where the main price block is,
      // so we will inject the Afterpay HTML before the cart form.
      // In future, we could consider scanning the DOM to find the main price block.
      $elements = $('form[action^="/cart/add"]');
      if ($elements.length > 0) {
        $target_element = $elements.first();
        injection_position = 'before';
        if (afterpay_shop_currency == 'USD') {
          $afterpay_paragraph.find('.afterpay-text1').html('Pay 4 installments of ');
        } else {
          $afterpay_paragraph.find('.afterpay-text1').html('Make 4 interest-free payments of ');
        }

        afterpay_ga('send', 'event', 'JS Include', 'Product Page - Search Complete', 'Cart Form Fallback');
      }
    }

  }

  // Render Afterpay HTML

  if ($target_element !== null) {
    // We have a place to inject the Afterpay HTML.
    // Render it on the page, but hide it if we need to.

    if (!afterpay_current_variant.available) {
      $afterpay_paragraph.hide();
    } else if (afterpay_current_variant.price < (afterpay_min * 100) || afterpay_current_variant.price > (afterpay_max * 100)) {
      if (afterpay_shop_currency == 'USD') {
        $afterpay_paragraph = Afterpay.generateOutsideLimitHTML($afterpay_paragraph);
      } else {
        $afterpay_paragraph.hide();
      }
    }

    if (typeof afterpay_product_css != 'undefined') {
      $afterpay_paragraph.css(afterpay_product_css);
    }

    $target_element[injection_position]($afterpay_paragraph);
  } else {
    afterpay_ga('send', 'event', 'JS Include', 'Product Page - Search Complete', 'No Match');
  }

  /**
   * Variable Price Fallback
   * 
   * If a change event is not triggering on the cart form
   * each time a new variant is being selected, but the product
   * price element is being updated by some other means,
   * use this fallback to watch for changes to the price element
   * instead.
   * 
   * If `MutationObserver` is supported by the browser it will be
   * used, otherwise it will fallback to `setInterval`.
   */

  if (afterpay_variable_price_fallback != false) {
    if (typeof afterpay_variable_price_fallback_selector != 'undefined') {
      $elements = $(afterpay_variable_price_fallback_selector);
      if ($elements.length > 0) {
        $watched_element = $elements.first();
      }
    }

    if ($watched_element === null && $target_element !== null) {
      $watched_element = $target_element;
    }

    if ($watched_element !== null) {
      if (Afterpay.mutationObserver) {
        dom_mutation_observer = new Afterpay.mutationObserver(function(mutations, observer) {
          var i;

          for (i = 0; i < mutations.length; i++) {
            if ($(mutations[i].target).is($watched_element)) {
              Afterpay.updateParagraph($afterpay_paragraph, Afterpay.extractPriceFromHTML(mutations[i].target.innerHTML));
            }
          }
        });

        dom_mutation_observer.observe($watched_element.get(0), {
          childList: true,
          attributes: false,
          characterData: false,
          subtree: true,
          attributeOldValue: false,
          characterDataOldValue: false
        });
      } else {
        setInterval(function(e) {
          Afterpay.updateParagraph($afterpay_paragraph, Afterpay.extractPriceFromHTML($watched_element.text()));
        }, 400);
      }
    }
  } else {
    $('body').on('change', $('form[action^="/cart/add"]'), function(event) {
      // There has been a change to the cart form.
      // Use the currently selected variant ID to recalculate the Afterpay instalments.
      // If the current selection is not eligible, hide the Afterpay HTML entirely.

      var $form = $(event.target).closest('form');
      var selected_variant_id = parseInt($('input[name=id]:checked, select[name=id], input[name=id], hidden[name=id]', $form).val(), 10);
      var should_show_instalments = false;

      if (!isNaN(selected_variant_id) && selected_variant_id > 0) {
        $.each(afterpay_product.variants, function(variant_index, variant) {
          if (variant.id == selected_variant_id) {
            if (variant.available) {
              if (variant.price >= (afterpay_min * 100) && variant.price <= (afterpay_max * 100)) {
                should_show_instalments = true;
                if (afterpay_shop_currency == 'USD') {
                  $afterpay_paragraph = Afterpay.generateInsideLimitHTML($afterpay_paragraph);
                }
                $afterpay_paragraph.find('.afterpay-instalments').html(Afterpay.generateInstalmentHTML(variant.price));
              } else if (afterpay_shop_currency == 'USD') {
                should_show_instalments = true;
                $afterpay_paragraph = Afterpay.generateOutsideLimitHTML($afterpay_paragraph);
              }
            }
          }
        });
      }
      if ($form.find('input[type=submit],button[type=submit]').is('[disabled]')) {
        // The submit button is disabled.
        // This most likely indicates that the product is not available,
        // therefore the Afterpay elements should be hidden.
        should_show_instalments = false;
      }
      if ($afterpay_paragraph !== null) {
        if (should_show_instalments) {
          $afterpay_paragraph.show();
        } else {
          $afterpay_paragraph.hide();
        }
      }
    });
  }
}

Afterpay.initStaticCartPage = function($) {

  // Define Variables

  var $elements = null;
  var $target_element = null;
  var injection_position = 'after';
  var $afterpay_paragraph;

  $afterpay_paragraph = Afterpay.renderParagraph($, {
    'total_price': afterpay_cart_total_price
  });

  if (typeof afterpay_cart_static_selector != 'undefined') {

    // Selector has been specified in the theme.liquid file.
    // Use this instead of running search passes.

    Afterpay.supportedTheme = true;

    $elements = $(afterpay_cart_static_selector);
    if ($elements.length > 0) {
      $target_element = $elements.first();
      if (afterpay_shop_currency != 'USD') {
        $afterpay_paragraph
          .find('.afterpay-text1').html('or 4 payments of ');
        $afterpay_paragraph
          .find('.afterpay-text2').html(' with ');
      }
      
      afterpay_ga('send', 'event', 'JS Include', 'Static Cart Page - Search Complete', 'Manual Override');
    }
  } else {

    // Search Pass 1: Theme Name Exact Match

    if (Afterpay.supportedTheme) {
      // The active theme is supported.
      // I.e: We know exactly where to inject the Afterpay HTML.

      $elements = $(Afterpay.supportedTheme.cart.static_page.selector);
      if ($elements.length > 0) {
        $target_element = $elements.first();
        if (afterpay_shop_currency != 'USD') {
          $afterpay_paragraph
            .find('.afterpay-text1').html('or 4 payments of ');
          $afterpay_paragraph
            .find('.afterpay-text2').html(' with ');
        }

        afterpay_ga('send', 'event', 'JS Include', 'Static Cart Page - Search Complete', 'Theme Name Exact Match');
      }
    }

    // Search Pass 2: Theme Name Partial Match

    else {
      $elements = null;

      $.each(Afterpay.supportedThemes, function(propertyName, valueOfProperty) {
        var pattern = new RegExp(propertyName, 'i');
        if (pattern.test(afterpay_theme_name)) {
          // The active theme name contains the name of a supported theme.
          // E.g.:
          //  - "Copy of Debut"      matches /Debut/i
          //  - "Supply with LayBuy" matches /Supply/i
          //  - "Pipeline2"          matches /Pipeline/i
          // Assume this is a supported theme that has been renamed.

          Afterpay.supportedTheme = Afterpay.supportedThemes[propertyName];
          $elements = $(Afterpay.supportedTheme.cart.static_page.selector);
        }
      });

      if ($elements !== null && $elements.length > 0) {
        $target_element = $elements.first();
        if (afterpay_shop_currency != 'USD') {
          $afterpay_paragraph
            .find('.afterpay-text1').html('or 4 payments of ');
          $afterpay_paragraph
            .find('.afterpay-text2').html(' with ');
        }

        afterpay_ga('send', 'event', 'JS Include', 'Static Cart Page - Search Complete', 'Theme Name Partial Match');
      }
    }

    // Search Pass 3: Common Elements
    //
    // If this pass finds a match it is regarded the same as
    // an exact match for a supported theme.

    if ($target_element === null) {
      $.each(Afterpay.commonElements.cart.static_page.subtotal_selector, function(indexInArray, value) {
        $elements = $(value);
        if ($elements.length > 0) {
          Afterpay.supportedTheme = true;

          $target_element = $elements.first();
          if (afterpay_shop_currency != 'USD') {
            $afterpay_paragraph
              .find('.afterpay-text1').html('or 4 payments of ');
            $afterpay_paragraph
              .find('.afterpay-text2').html(' with ');
          }

          afterpay_ga('send', 'event', 'JS Include', 'Static Cart Page - Search Complete', 'Common Element Match');

          return false;
        }
      });
    }

    // Search Pass 4: Fallback

    if ($target_element === null) {
      // The active theme is NOT supported, OR the expected markup was not available.
      // We don't know where the subtotal price block is,
      // so we will inject the Afterpay HTML:
      //  a) before the "Continue Shopping" / "Update Cart" buttons, or
      //  b) after the cart form.

      $afterpay_paragraph
      .css({
        'text-align': 'right'
      });

      if (afterpay_shop_currency == 'USD') {
        $afterpay_paragraph.find('.afterpay-text1').html('Pay 4 installments of ');
      } else {
        $afterpay_paragraph.find('.afterpay-text1').html('Make 4 payments of ');
      }

      $elements = $('a[href="collections/all"],input[name=update]');

      if ($elements.length > 0) {
        $target_element = $elements.first();
        injection_position = 'before';

        afterpay_ga('send', 'event', 'JS Include', 'Static Cart Page - Search Complete', 'Cart Button Fallback');
      } else {
        $elements = $('form[action^="/cart"]:not(form[action^="/cart/add"])');

        if ($elements.length > 0) {
          $target_element = $elements.first();

          afterpay_ga('send', 'event', 'JS Include', 'Static Cart Page - Search Complete', 'Cart Form Fallback');
        }
      }
    }

  }

  // Render Afterpay HTML

  if ($target_element !== null) {
    // We have a place to inject the Afterpay HTML.
    // Render it on the page, but hide it if we need to.

    if (afterpay_cart_total_price < (afterpay_min * 100) || afterpay_cart_total_price > (afterpay_max * 100)) {
      if (afterpay_shop_currency == 'USD') {
        $afterpay_paragraph.find('.afterpay-text1')
          .html('Installments by ');
        $afterpay_paragraph.find('.afterpay-logo')
          .insertAfter($afterpay_paragraph.find('.afterpay-text1'));
        $afterpay_paragraph.find('.afterpay-text2')
          .html(' available between ');
        $afterpay_paragraph.find('.afterpay-instalments')
          .html(Afterpay.generateCurrencyHTML(afterpay_min) + ' - ' + Afterpay.generateCurrencyHTML(afterpay_max))
          .insertAfter($afterpay_paragraph.find('.afterpay-text2'));
        $afterpay_paragraph.find('.afterpay-link-inner').html('Learn more');
      } else {
        $afterpay_paragraph.hide();
      }
    }

    if (typeof afterpay_cart_static_css != 'undefined') {
      $afterpay_paragraph.css(afterpay_cart_static_css);
    }

    $target_element[injection_position]($afterpay_paragraph);
  } else {
    afterpay_ga('send', 'event', 'JS Include', 'Static Cart Page - Search Complete', 'No Match');
  }
}

Afterpay.init = function($) {

  Afterpay.supportedTheme = Afterpay.supportedThemes[afterpay_theme_name.toLowerCase()];
  Afterpay.mutationObserver = window.MutationObserver || window.WebKitMutationObserver;

  var dom_mutation_observer;

  if (/^\/cart/i.test(window.location.pathname)) {

    // This is almost certainly the static Cart page.

    if (afterpay_cart_integration_enabled != false) {
      Afterpay.initStaticCartPage($);
    }

  } else if (/^\/(collections|products)/i.test(window.location.pathname) && afterpay_product) {

    // This is probably a Product page.

    Afterpay.initProductPage($);

  }

  /**
   * For dynamic cart implementations,
   * the following solution utilises MutationObserver
   * to detect when `addedNode_selector` is added
   * as a child of `target_selector`, at which time
   * the Afterpay paragraph is appended after
   * the newly added `subtotal_selector`.
   * Note that the subtotal must be a child of the added node.
   */
  if (afterpay_cart_integration_enabled != false && Afterpay.supportedTheme && Afterpay.supportedTheme.hasOwnProperty('cart') && Afterpay.supportedTheme.cart.hasOwnProperty('dynamic_content') && Afterpay.supportedTheme.cart.dynamic_content.hasOwnProperty('target_selector') && Afterpay.supportedTheme.cart.dynamic_content.hasOwnProperty('addedNode_selector') && Afterpay.supportedTheme.cart.dynamic_content.hasOwnProperty('subtotal_selector')) {
    if (Afterpay.mutationObserver) {
      dom_mutation_observer = new Afterpay.mutationObserver(function(mutations, observer) {
        var i, j;

        for (i = 0; i < mutations.length; i++) {
          if (Afterpay.supportedTheme) {
            if ($(mutations[i].target).is(Afterpay.supportedTheme.cart.dynamic_content.target_selector)) {
              for (j = 0; j < mutations[i].addedNodes.length; j++) {
                if (typeof mutations[i].addedNodes[j] == 'object') {
                  if ($(mutations[i].addedNodes[j]).is(Afterpay.supportedTheme.cart.dynamic_content.addedNode_selector)) {
                    var $afterpay_paragraph = Afterpay.renderParagraph($, {
                      'total_price': afterpay_cart_total_price
                    });

                    if (afterpay_shop_currency != 'USD') {
                      $afterpay_paragraph
                        .find('.afterpay-text1').html('or 4 payments of ');
                      $afterpay_paragraph
                        .find('.afterpay-text2').html(' with ');
                    }

                    if (afterpay_cart_total_price < (afterpay_min * 100) || afterpay_cart_total_price > (afterpay_max * 100)) {
                      if (afterpay_shop_currency == 'USD') {
                        $afterpay_paragraph.find('.afterpay-text1')
                          .html('Installments by ');
                        $afterpay_paragraph.find('.afterpay-logo')
                          .insertAfter($afterpay_paragraph.find('.afterpay-text1'));
                        $afterpay_paragraph.find('.afterpay-text2')
                          .html(' available between ');
                        $afterpay_paragraph.find('.afterpay-instalments')
                          .html(Afterpay.generateCurrencyHTML(afterpay_min) + ' - ' + Afterpay.generateCurrencyHTML(afterpay_max))
                          .insertAfter($afterpay_paragraph.find('.afterpay-text2'));
                        $afterpay_paragraph.find('.afterpay-link-inner').html('Learn more');
                      } else {
                        $afterpay_paragraph.hide();
                      }
                    }

                    if (typeof afterpay_cart_dynamic_css != 'undefined') {
                      $afterpay_paragraph.css(afterpay_cart_dynamic_css);
                    }

                    $(Afterpay.supportedTheme.cart.dynamic_content.target_selector)
                      .find(Afterpay.supportedTheme.cart.dynamic_content.addedNode_selector)
                      .find(Afterpay.supportedTheme.cart.dynamic_content.subtotal_selector).after($afterpay_paragraph);
                    
                    if (Afterpay.supportedTheme.cart.dynamic_content.paragraph_css) {
                      $afterpay_paragraph.css(Afterpay.supportedTheme.cart.dynamic_content.paragraph_css);
                    }
                    
                    if (typeof Afterpay.supportedTheme.cart.dynamic_content.after_render == 'function') {
                      Afterpay.supportedTheme.cart.dynamic_content.after_render($, $afterpay_paragraph);
                    }

                    afterpay_ga('send', 'event', 'JS Include', 'Dynamic Cart Content - Update', 'Afterpay HTML Rendered After DOM Mutation');
                  }
                }
              }
            }
          }
        }
      });

      dom_mutation_observer.observe(document, {
        childList: true,
        attributes: false,
        characterData: false,
        subtree: true,
        attributeOldValue: false,
        characterDataOldValue: false
      });
    } else {
      // @todo Use an interval instead.
    }

    /**
     * Update our cached value of the cart total
     * when the cart is updated via ajax.
     */
    $(document).ajaxComplete(function(event, xhr, settings) {
      if (settings.url == '/cart') {
        var $subtotal_element = $(xhr.responseText).find(Afterpay.supportedTheme.cart.dynamic_content.subtotal_selector).find('span.visually-hidden');
        if ($subtotal_element.length > 0) {
          var subtotal_formatted_str = $subtotal_element.text();
          var subtotal_int = Number(subtotal_formatted_str.replace(/[^0-9]/g, ''));
          afterpay_cart_total_price = subtotal_int;
          //$(Afterpay.supportedTheme.cart.dynamic_content.target_selector).find('.afterpay-instalments').html(Afterpay.generateInstalmentHTML(subtotal_int));

          afterpay_ga('send', 'event', 'JS Include', 'Dynamic Cart Content - Update', 'Afterpay HTML Updated After AJAX Complete');
        } else {
          afterpay_ga('send', 'event', 'JS Include', 'Dynamic Cart Content - Update', 'Afterpay HTML Not Updated After AJAX Complete');
        }
      } else if (settings.url == '/cart/change.js') {
        if (xhr.status == 200 && xhr.statusText == 'OK') {
          var subtotal_int = xhr.responseJSON.total_price;
          afterpay_cart_total_price = subtotal_int;
          // Don't update the DOM immediately, just save the amount in memory and
          // wait for the whole block to redraw.
          // Our MutationObserver will pick it up later.
          // If we do it now, our instalment text will update before the subtotal.
          //$(Afterpay.supportedTheme.cart.dynamic_content.target_selector).find('.afterpay-instalments').html(Afterpay.generateInstalmentHTML(subtotal_int));
          
          afterpay_ga('send', 'event', 'JS Include', 'Dynamic Cart Content - Update', 'Afterpay Cart Total Updated After AJAX Complete');
        }
      }
    });
  }
};

if (typeof afterpay_cart_integration_enabled == 'undefined') {
  var afterpay_cart_integration_enabled;
  if (afterpay_shop_currency == 'USD') {
    afterpay_cart_integration_enabled = true;
  } else {
    afterpay_cart_integration_enabled = false;
  }
}
if (typeof afterpay_variable_price_fallback == 'undefined') {
  var afterpay_variable_price_fallback = false;
}
if (typeof afterpay_ga_enabled == 'undefined') {
  var afterpay_ga_enabled = false;
}

if (afterpay_shop_currency == 'USD') {
  afterpay_min = Math.max(afterpay_min, 35.00);
} else {
  afterpay_min = Math.max(afterpay_min, 0.04);
}

if (afterpay_ga_enabled != false) {
  (
    function(i,s,o,g,r,a,m){
      i['GoogleAnalyticsObject']=r;
      i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments);
      },i[r].l=1*new Date();
      a=s.createElement(o),m=s.getElementsByTagName(o)[0];
      a.async=1;
      a.src=g;
      m.parentNode.insertBefore(a,m);
    }
  )(window,document,'script','https://www.google-analytics.com/analytics.js','afterpay_ga');
} else {
  function afterpay_ga(a,b,c,d,e){}
}
afterpay_ga('create', 'UA-108913162-2', {'sampleRate': 1});
afterpay_ga('send', 'event', 'JS Snippet', 'Report Version', afterpay_js_snippet_version);
afterpay_ga('send', 'event', 'JS Include', 'Report Version', '1.3.8');
afterpay_ga('send', 'event', 'Theme', 'Report Name', afterpay_theme_name);
afterpay_ga('send', 'event', 'Shop', 'Report Currency', afterpay_shop_currency);

if (Afterpay.arrayContainsElement(Afterpay.supportedCurrencies, afterpay_shop_currency)) {
  // The store currency is compatible with Afterpay.
  // Proceed.

  if (typeof jQuery != 'function' || !Object.prototype.hasOwnProperty.call(jQuery, 'fn') || parseFloat(jQuery.fn.jquery) < 1.7) {
    // jQuery is not loaded or too old, load 1.12.4 from Google with "noConflict",
    // then use it to initialise the Afterpay script.
    Afterpay.loadScript('https://ajax.googleapis.com/ajax/libs/jquery/1.12.4/jquery.min.js', function() {
      var jQuery_1_12_4 = jQuery.noConflict(true);
      Afterpay.init(jQuery_1_12_4);
    });
  } else {
    // A compatible version of jQuery is already available.
    // Use it to initialise the Afterpay script.
    Afterpay.init(jQuery);
  }
}
